import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  PDFLabelSet,
  type PDFLabelSetConstructor,
  type OrderItemLabels,
  type POLabels,
} from './PDFLabelSet'

const OrderItemLabelsFactory = Factory.Sync.makeFactory<OrderItemLabels>({
  itemDescription: Factory.each(() => faker.lorem.word()),
  totalPrice: Factory.each(() => faker.lorem.word()),
  poNote: Factory.each(() => faker.lorem.word()),
  price: Factory.each(() => faker.lorem.word()),
  quantity: Factory.each(() => faker.lorem.word()),
  sku: Factory.each(() => faker.lorem.word()),
  unit: Factory.each(() => faker.lorem.word()),
})

const POLabelsFactory = Factory.Sync.makeFactory<POLabels>({
  poNumber: Factory.each(() => faker.lorem.word()),
  purchaseOrder: Factory.each(() => faker.lorem.word()),
  shipTo: Factory.each(() => faker.lorem.word()),
  comment: Factory.each(() => faker.lorem.word()),
  creditcard: Factory.each(() => faker.lorem.word()),
  date: Factory.each(() => faker.lorem.word()),
  discount: Factory.each(() => faker.lorem.word()),
  freight: Factory.each(() => faker.lorem.word()),
  other: Factory.each(() => faker.lorem.word()),
  paymentTerms: Factory.each(() => faker.lorem.word()),
  prefVendor: Factory.each(() => faker.lorem.word()),
  promiseDate: Factory.each(() => faker.lorem.word()),
  shippingMethod: Factory.each(() => faker.lorem.word()),
  shippingTerms: Factory.each(() => faker.lorem.word()),
  subtotal: Factory.each(() => faker.lorem.word()),
  tax: Factory.each(() => faker.lorem.word()),
  total: Factory.each(() => faker.lorem.word()),
})

export const PDFLabelSetConstructorFactory =
  Factory.Sync.makeFactory<PDFLabelSetConstructor>({
    isPrimary: Factory.each(() => faker.random.boolean()),
    key: Factory.each(() => faker.random.uuid()),
    value: Factory.each(() => ({
      name: faker.lorem.words(),
      orderitem: OrderItemLabelsFactory.build(),
      po: POLabelsFactory.build(),
    })),
  })

export const PDFLabelSetFactory = EntityFactory(
  PDFLabelSet,
  PDFLabelSetConstructorFactory
)
